import type * as React from 'react'

import _CheckboxGroup from '../_CheckboxGroup/_CheckboxGroup'
import type { Props as _CheckboxProps } from './_Checkbox'
import _Checkbox from './_Checkbox'

type CompoundedComponent = React.ForwardRefExoticComponent<
  _CheckboxProps & React.RefAttributes<HTMLInputElement>
> & {
  Group: typeof _CheckboxGroup
}

const _CheckboxBinder = _Checkbox as CompoundedComponent
_CheckboxBinder.Group = _CheckboxGroup

/**
 * @deprecated `atoms/Checkbox/Checkbox/Checkbox` (신규 — ds-2024 wrapping) 사용. 본 binder 는 호출부 점진 마이그 중.
 */
export default _CheckboxBinder
